import collaborators from './collaborators';
import userWorkflowDetails from './userWorkflowDetails';

export default {
  collaborators,
  userWorkflowDetails,
};